import { API_URL } from "../config/connect";

/** [{ id, name_ru, name_kz, ... }] — области */
export const getRegions = async () => {
    const response = await fetch(`${API_URL}/api/v1/regions`);
    if (!response.ok) throw new Error(`Не удалось загрузить регионы (${response.status})`);
    const data = await response.json();
    return data.regions || [];
};

/** [{ id, region_id, name_ru, ... }] — районы области */
export const getDistricts = async (regionId) => {
    const response = await fetch(`${API_URL}/api/v1/districts?region_id=${regionId}`);
    if (!response.ok) throw new Error(`Не удалось загрузить районы (${response.status})`);
    const data = await response.json();
    return data.districts || [];
};
